import { ReducerType } from '../ReducerType'
import reducerDevice from './deviceSlice'
import reducerUser from './userSlice'
import reducerPrescription from './prescriptionSlice'
import reducerAppointment from './appoinemntsSlice'
import reducerCenter from './centerSlice'
import reducerQueue from './queueSlice'
import reducerDateFilter from './datesFilterSlice'
import reducerPen from "./penImageSlice";
import { combineReducers } from 'redux'

const reducers = combineReducers<ReducerType>({
  reducerAppointment,
  reducerDevice,
  reducerUser,
  reducerPrescription,
  reducerCenter,
  reducerQueue,
  reducerDateFilter,
  reducerPen
})
export default reducers
